module.exports = __webpack_public_path__ + "static/media/play.d7f365b4.png";